<template>
  <div class="page-wrap">
    <JobList></JobList>
    <transition name="main" mode="out-in">
      <keep-alive>
        <router-view @scroll.native.stop="()=>{}" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import JobList from "@/views/pages/JobList";
import hr from "../../assets/js/index.js";
export default {
  components: {
    JobList,
  },
  created() {
    // 请求数据，组合各job内容
    this.$http.post("/api/dataapi/job?whid=wenhua").then((res) => {
      if (res.status != 200 || !res.data) return;
      let jobList = res.data;

      jobList.forEach((item, index) => {
        if (item.listH && item.listH.length > 0) {
          item.baseHtml = this.makeBaseInfo(item.listH);
        }
        if (item.listV && item.listV.length > 0) {
          item.detailHtml = this.makeDetailInfo(item.listV);
        }
      });

      this.$store.commit("setJobList", jobList);
    });
    // 请求job分组数据
    this.$http.post("/api/dataapi/JobType?whid=wenhua").then((res) => {
      if (res.status != 200 || !res.data) return;
      let jobNav = res.data || [];
      this.$store.commit("setJobNav", jobNav);
    });
  },
  methods: {
    makeBaseInfo(data) {
      let html = "";
      let salary = "",
        position = "",
        kind = "",
        personCount = "";
      data.forEach((item, index) => {
        if (item.name == "工作性质") {
          kind = "&nbsp;&nbsp;|&nbsp;&nbsp;" + item.note;
        } else if (item.name == "起薪") {
          salary = item.name + "：" + this.delc(item.note);
        } else if (item.name == "招聘人数") {
          personCount = "&nbsp;&nbsp;|&nbsp;&nbsp;招聘" + item.note + "人";
        } else if (item.name == "工作地点") {
          position = item.note;
        }
      });
      html = salary + "<br>" + position + kind + personCount;
      return html;
    },
    makeDetailInfo(data) {
      let html = "";
      data.forEach((item, index) => {
        html +=
          '<div class="detail-row">\
                  <div style="font-weight: bold;line-height: 1rem;">' +
          item.name +
          '</div>\
                  <div style="line-height: 1rem;">' +
          this.changeRN(item.note) +
          "</div>\
                </div><br>";
      });
      return html;
    },
    delc(str) {
      var text = str.replace(/<\\c>/g, "");
      return text;
    },
    changeRN: hr.changeRN,
  },
};
</script>

<style scoped>
.page-wrap {
  
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.main-enter-active,
.main-leave-active {
  transition: all 0.15s;
}

.main-enter,
.main-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>